export enum LookupType {
  // Sitecore Lookups
  Country = 2,
  City = 3,
  Mission = 10,
  TheEmirates = 8,
  HappinessCentres = 18,
  SitecoreDepartments = 22,

  // EServices Lookups
  MeansOfTravel = 100,
  DisabilityNature = 101,
  Service = 102,
  ServiceStatus = 103,
  Currency = 105,
  CertificateConfiguration = 106,
  CommercialConfiguration = 107,
  RejectionReason = 108,
  CRMServices = 109,
  ExternalServiceStatus = 110,
  CertificatesFeesConfiguration = 111,
  CommercialFeesConfiguration = 112,
  InvoiceFeesConfiguration = 113,
  Department = 114,
  SLAService = 115,
  SLAServiceStage = 116,
  DaysOfWeek = 117,
  ComplaintSubject = 118,
  CrisisType = 119,
  InquirySubject = 120,
  AccidentNature = 121,
  CertificatePurpose = 122,
  NationalAffairsService = 123,
  NationalAffairsServiceStatus = 124,
  DiplomaticApplicantCategory = 126,
  DiplomaticRelativeRelation = 127,
  IDType = 125,
  DiplomaticPassportCancelReason = 128,
  DiplomaticPassportModificationReason = 129,
  DiplomaticPassportRenewalReason = 130,
  ReasonsForResidingInUAE = 131,
  TwajudiResidentsStatus = 132,
  ReasonsForStayingOutside = 133,
  CompanyAttestationRequets = 134,
  AppointmentsHappinessCenters = 135,
  AramexArea = 136,
  EMPostRegion = 137,
  EMPostEmirates = 138,
  TawzeaEmirates = 139,
  ZajelEmirates = 140,
  TawzeaLandmark = 141,
  ZajelAreas = 142,
  AramexEmirates = 143,
  VFSConfigurationTMP = 144,
  VFSStateCity = 146,
  AttestationCountryConfig = 145,
  VFSConfiguration = 147,
  VFSState = 148,
  VFSCity = 149,

  //CRM Lookup
  CRMCountry = 200,
  CRMCity = 201,
  CRMCaseRegardingComplaint = 202,
  CRMMission = 203,
  CRMCaseRegardingSuggestion = 204,
  CRMCaseRegardingInquiry = 205,
  CRMTheEmirates = 206,
  CRMApplicantCategory = 207,
  CRMPassportRequestType = 208,
  CRMDiplomaticType = 209,
  CRMDiplomaticPassportType = 210,
  CRMDiplomaticMaritalStatus = 211,
  CRMVehicleDiplomaticIDType = 212,
  CRMPlateNumberType = 213,
  CRMVehicleType = 214,
  CRMGender = 215,
  CRMPossessionType = 216,
  CRMSellerType = 217,
  CRMBuyerType = 218,
  CRMAutomationParentServices = 221,
  CRMAutomationChildServices = 222,
  CRMPermitType = 223,
  CRMAirport = 224,
  CRMReplacementType = 225,
  CRMVisitType = 226,
  CRMArrivalAirlineType = 227,
  CRMBloodType = 228,
  CRMAirportAreas = 229,
  CRMVisitAirports = 230,
  CRMTitle = 231,
  CRMDurationUnit = 232,
  CRMTeamFlightType = 233,
  CRMReligion = 234,
  CRMDenomination = 235,
  Proffession = 236,
  CRMRelationshipWithMaster = 237,
  CRMNewCountry = 238,
  CRMNewCity = 239,
  CRMNewArea = 240,
  CRMChildCity = 241,
  CRMDiplomaticPassportReplacementType = 242,
  CRMVisaType = 246,
  CRMVisaIssuancePlace = 245,
  CRMMofaVehicleTypeAuh = 248,
  CRMRequestType = 249,
  CRMTeamFlightNew = 250,
  CRMDiplomaticPassportCancelReason = 251,
  CRMNewOwnerType = 252,
  CRMBuyerTypeAuh = 253,
  CRMMofaEntryPort = 254,
  CRMMofaReasonForReplacement = 255,
  CRMMofaDiplomaticCardType = 256,
  CRMMofaTypeOfServiceBeneficiary = 257,
  CRMMofaDrivingLicenseType = 258,
  CRMMofaServiceType = 259,
  CRMMofaPositionToBeAllocated = 260,
  CRMMofaExitPort = 261,
  CRMMMofaicCardType = 262,
  CRMMofaFinedBy = 263,
  CRMPassingType = 264,
  CRMEntryAirport = 270,
  CRMCourierType = 271,
  CRMPassportType = 272,
  CRMVisitorTitle = 265,
  CRMTaxApplicantType = 266,
  CRMTaxOrgBeneficiaryType = 267,
  CRMTaxIndividualBeneficiaryType = 268,
  CRTaxMRequestOrigin = 269,
  CRMVisaServiceType = 273,
  HostingAuthorityLookup = 274,
  CRMMofaSubserviceType = 276,
  CRMMofaServiceParentType = 277,
  CRMMofaConcernedWith = 278,
  CRMMofaEmirateInWhichTheCompanyIsLocated = 279,
  CRMMofaEmirateOfThePresence = 280,
  CRMMofaEmirateOfTheWorkplace = 281,
  CRMMofaNationality = 282,
  CRMMofaOthernationality = 283,
  CRMMofaEnabledCountries = 285,
  CRMGenderEmergency = 300,
  CRMEventType = 301,
  CRMParticipationType = 302,
  CRMSpeechLetterType = 303,
  CRMOccasionType = 304,
  CRMTelegramtype = 305,
  CRMInviteeTitle = 306,
  CRMEducationLevel = 307,
  CRMAcademicYear = 308,
  CRMCertificateIssuedBy = 309,
  CRMPatientgender = 310,
  CRMVisitortype = 400,
  CRMPrisonVisittype = 401,
  CRMPrison = 402,
  CRMPoliceStation = 403,
  CRMUAEEmirates = 404,
  CRMAVMRPApplicationType = 405,
  CRMAVMRPPermitType = 406,
  CRMAVMRPBerthType = 407,
  CRMCallerTitle = 408,
  CRMReceiverTitle = 409,
  CRMIntlJudicialCoopSubService = 410,
  CRMIntlJudicialCoopConcerning = 411,
  CRMMOFACaliber = 412,
  CRMTransportMode = 413,
  CRMEducationalStreams = 420,
  CRMcurriculum = 421,
  CRMcontractissuedby = 422,
  CRMTWIMCIdentityType = 423,
  CRMIntlJudicialCoopCaseType = 424,
  CRMIntlJudicialCoopEntityType = 425,
  CRMIntlJudicialCoopLawsuitType = 426,
  CRMVDOVisitType = 427,
  CRMVDOCoordinatorTitle = 428,
  CRMVDOPassportType = 429,
  CRMVDOMemberTitle = 430,


  // on the fly lookups in .ts only
  CRMEquipmentsUser = 1000,

  //EDAS Lookups
  EDASDocCategory = 500,
  EDASDocEntity = 501,
  EDASCountry = 502,
}
